// src/features/settings/services/nonWorkingDays.js
// Unified service for public holidays + closing days ("non-working days").
// Replaces the old closingDays.js (settings) and publicHolidays.js (tidsregistering) services.
import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/tidsregistering/non-working-days';

export const nonWorkingDaysAPI = {
  // List non-working days (paginated, optional kind/auto_generated filters)
  list: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.kind) queryParams.append('kind', params.kind);
    if (params.auto_generated !== undefined && params.auto_generated !== null) {
      queryParams.append('auto_generated', params.auto_generated);
    }
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.offset) queryParams.append('offset', params.offset);

    const queryString = queryParams.toString();
    return apiClient.get(`${BASE}/${queryString ? `?${queryString}` : ''}`);
  },

  // Get a single non-working day by id
  getById: (nonWorkingDayId) =>
    apiClient.get(`${BASE}/${nonWorkingDayId}`),

  // Get expanded (day-by-day) non-working days within a date range
  getExpanded: (startDate, endDate, kind) => {
    const queryParams = new URLSearchParams();
    queryParams.append('start_date', startDate);
    queryParams.append('end_date', endDate);
    if (kind) queryParams.append('kind', kind);
    return apiClient.get(`${BASE}/expanded?${queryParams.toString()}`);
  },

  // --- Public holidays ---

  createPublicHoliday: (data) =>
    apiClient.post(`${BASE}/public-holidays`, data),

  // Limited-field update: only is_full_day/free_from can change
  updatePublicHolidayHours: (nonWorkingDayId, data) =>
    apiClient.put(`${BASE}/public-holidays/${nonWorkingDayId}`, data),

  // Self-service generation for the caller's own department
  generateHolidays: (data) =>
    apiClient.post(`${BASE}/public-holidays/generate`, data),

  // Admin cross-department generation (requires admin_generate scope)
  adminGenerateHolidaysForDepartment: (departmentId, data) =>
    apiClient.post(`${BASE}/public-holidays/generate/${departmentId}`, data),

  // --- Closing days ---

  createClosingDayDateRange: (data) =>
    apiClient.post(`${BASE}/closing-days/date-range`, data),

  createClosingDayRRule: (data) =>
    apiClient.post(`${BASE}/closing-days/rrule`, data),

  updateClosingDayDateRange: (nonWorkingDayId, data) =>
    apiClient.put(`${BASE}/closing-days/${nonWorkingDayId}/date-range`, data),

  updateClosingDayRRule: (nonWorkingDayId, data) =>
    apiClient.put(`${BASE}/closing-days/${nonWorkingDayId}/rrule`, data),

  // --- Shared ---

  deleteNonWorkingDay: (nonWorkingDayId) =>
    apiClient.delete(`${BASE}/${nonWorkingDayId}`),
};
